import { Link } from "react-router-dom";
import React, { Component } from "react";
import { Sidebar, Menu, SubMenu, MenuItem } from "react-pro-sidebar";
import { readStorageJSON, project, profile, isCustomerProfile, GET, POST, PUT, alert, format_date, loading } from "./CustomComponent.js";
import { getAccessSides, sideOfPath } from "./access-side.js";
import { stripJuristic } from "./text-sanitize.js";
import { PUBLISH_STATUS, PUBLISH_BADGE, publishStatusOf } from "../constants/sale.js";
import Dropdown from "react-bootstrap/Dropdown";
import { Modal, Toast } from "react-bootstrap";
import LOGO from "../assets/images/logo.png";
import "../assets/css/bootstrap.css";

export default class NavbarComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_detail: false,
      modal_change_password: false,
      sidebar: false,
      profiles: null,
      array_link: [...this.filterMenu(profile)],

      detail: null,
      old_password: "",
      new_password: "",

      announce_image: "",
      announce_description: "",
      announce_is_active: "",

      // ป้ายสถานะประกาศขายของห้องตัวเอง (เฉพาะลูกบ้าน) — ดู GetListingBadge
      listing_badge: null,
    };
  }

  async componentDidMount() {
    this.GetAnnounce();
    this.GetProfile();
    this.GetListingBadge();
    this.replaceTextHTML();
  }
  async componentDidUpdate() {
     this.permissionSetting();
     this.replaceTextHTML();
  }
  replaceTextHTML = async () => {
  const item = readStorageJSON("cds-setting");

  let water_bill_text = item?.setting_water?.water_bill_text || "ค่าน้ำประปา";
  let meter_connect_cost_text = item?.setting_water?.meter_connect_cost_text || "ค่าต่อมิเตอร์";
  let equipment_maintenance_fee_text = item?.setting_water?.equipment_maintenance_fee_text || "ค่าบริการอุปกรณ์";
  let waste_cost_text = item?.setting_water?.waste_cost_text || "ค่าขยะ";
  let common_expenses_text = item?.setting_water?.common_expenses_text || "ค่าส่วนกลาง";
  let fire_cost_text = item?.setting_water?.fire_cost_text || "ค่าเบี้ยประกัน";
  let cable_cost_text = item?.setting_water?.cable_cost_text || "ค่าเคเบิล";
  document.body.querySelectorAll("*").forEach((el) => {
    el.childNodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        let text = node.textContent;

        text = text.includes(water_bill_text) ? text : text.replace(/ค่าน้ำประปา|ค่าน้ำ ประปา|ค่าน้ำประปา|ค่าใช้น้ำ/g, water_bill_text);
        text = text.includes(meter_connect_cost_text) ? text : text.replace(/ค่าต่อกลับ มิเตอร์|ค่าต่อ มิเตอร์|ค่าต่อมิเตอร์|ค่าต่อกลับมิเตอร์/g, meter_connect_cost_text);
        text = text.includes(waste_cost_text) ? text : text.replace(/ค่าขยะ|ค่าจัดเก็บขยะ|ค่าบริการจัดเก็บขยะ/g, waste_cost_text);
        text = text.includes(common_expenses_text) ? text : text.replace(/ค่าใช้จ่ายส่วนกลาง|ค่าส่วนกลาง|ค่าส่วน\s*กลาง|ค่า\s*ส่วนกลาง|ค่า ส่วนกลาง|ค่าใช้จ่าย\s*ส่วนกลาง/g, common_expenses_text);
        text = text.includes(fire_cost_text) ? text : text.replace(/ค่าประกันอัคคีภัย|ค่าเบี้ยประกัน/g, fire_cost_text);
        text = text.includes(cable_cost_text) ? text : text.replace(/ค่าเคเบิล|ค่าบริการเคเบิล/g, cable_cost_text);
        text = text.includes(equipment_maintenance_fee_text) ? text : text.replace(/ค่ารักษา อุปกรณ์น้ำ|ค่าบริการรักษาอุปกรณ์น้ำ|ค่ารักษาอุปกรณ์การใช้น้ำ|ค่าบริการอุปกรณ์|ค่ารักษาอุปกรณ์น้ำ|ค่ารักษาอุปกรณ์|ค่าบริการ\s*อุปกรณ์|ค่ารักษา อุปกรณ์|ค่ารักษา\s*อุปกรณ์|ค่าบริการ/g, equipment_maintenance_fee_text);

        if (node.textContent !== text) {
          node.textContent = text;
        }
      }
    });
  });
};
  icon = (icon) => {
    return <label className="icon">{icon}</label>;
  };

  GetAnnounce = async () => {
      // ★ ประกาศผูกกับโครงการ — ยังไม่เลือกโครงการ (หน้าระดับผู้ดูแล เช่น ผู้ใช้/สิทธิ์/logs)
      //   backend ตอบ 400 "ไม่พบโครงการ" ทุกหน้า จึงไม่เรียกเลย (ไม่มีโครงการ = ไม่มีประกาศให้แสดงอยู่แล้ว)
      //   อ่าน cds-project สด ๆ แบบเดียวกับ header project-id ใน GET (getCurrentProject)
      let currentProject = null;
      try { currentProject = JSON.parse(localStorage.getItem("cds-project") || "null"); } catch (e) { currentProject = null; }
      if (!currentProject?.project_id) return;
      loading(true);
      let result = await GET("api/admin/announcements/list", null, false);
      if (result?.status) {
        this.setState({ 
          announce_image: result.data?.image,
          announce_description: result.data?.description,
          announce_is_active: result.data?.is_active,});
      }
      loading(false);
    };

  // ★ merge ทับของเดิม ไม่ใช่เขียนทับทั้งก้อน
  //   /user/profile ไม่ได้คืนทุกฟิลด์ที่ตอน login เก็บไว้ (เช่น user_type ของลูกบ้าน)
  //   เขียนทับตรง ๆ แล้วเมนูจะตกไป branch ผิดตั้งแต่โหลดหน้าแรก
  mergeProfile = (data) => {
    const cached = readStorageJSON("cds-profile");
    const merged = { ...(cached || {}), ...data, password: "" };
    localStorage.setItem("cds-profile", JSON.stringify(merged));
    return merged;
  };

  GetProfile = async () => {
    const result = await GET("api/admin/user/profile");
    if (result?.status) {
      const merged = this.mergeProfile(result.data);
      this.setState({
        profiles: merged,
        array_link: [...this.filterMenu(merged)],
      });
      this.permissionSetting();
    }
  };

  ChangePassword = async () => {
    const { profiles, old_password, new_password } = this.state;
    if (!old_password) {
      await alert("", "warning", "แจ้งเตือน", "กรุณากรอกรหัสผ่านเดิม");
      return;
    }
    if (!new_password) {
      await alert("", "warning", "แจ้งเตือน", "กรุณากรอกรหัสผ่านใหม่");
      return;
    }
    const username = localStorage.getItem("cds-username") || profiles.username;
    loading(true);
    const verify = await POST("api/public/login", { username, password: old_password });
    if (verify?.status === true) {
      localStorage.setItem("cds-acc-tk", btoa("Bearer " + verify.data.token));
      // payload ของ login ไม่มี role/permissions — ต้อง merge ไม่งั้นสิทธิ์หายทั้งชุด
      this.mergeProfile(verify.data);
    } else {
      loading(false);
      await alert("", "warning", "แจ้งเตือน", "รหัสผ่านเดิมไม่ถูกต้อง");
      return;
    }
    const _profile = await GET("api/admin/user/profile", null, null, "Bearer " + verify.data.token);
    const result = await PUT(`api/admin/customer/update/${_profile.data.customer_id}`, { username, password: new_password }, "Bearer " + verify.data.token);
    loading(false);
    if (result?.status === true) {
      await alert("", "success", "สำเร็จ", "เปลี่ยนรหัสผ่านเรียบร้อยแล้ว");
      this.setState({ modal_change_password: false, old_password: "", new_password: "" });
    } else {
      await alert("", "warning", "แจ้งเตือน", result?.message || "เกิดข้อผิดพลาด");
    }
  };

  GetCustomer = async () => {
    loading(true)
    const { profiles } = this.state;
    const result = await GET("api/admin/customer/list",{customer_id: profiles?.customer_id});
    if (result?.status) {
      this.setState({detail: result.data, modal_detail: true})
    }
    loading(false)
  };


  // ป้ายบนเมนู "จัดการทรัพย์" ของลูกบ้าน — บอกตั้งแต่เมนูว่าห้องตัวเองลงขายถึงไหนแล้ว
  //
  // ★ ยิงเฉพาะลูกบ้าน (customer/list ฝั่ง backend คืนเฉพาะห้องของตัวเองอยู่แล้ว)
  //   ฝั่งผู้ดูแลมีหลายร้อยห้อง ป้ายเดียวบอกอะไรไม่ได้ จึงไม่ต้องยิง
  // ★ ป้ายสถานะมาจาก constants/sale.js ชุดเดียวกับหน้าจัดการทรัพย์ — คำ/สีต้องตรงกันทุกหน้า
  LISTING_BADGE = {
    none: { label: "ยังไม่มีประกาศ", tint: "#f1e8f8", color: "#6b21a8" },
    pending: PUBLISH_BADGE[PUBLISH_STATUS.PENDING],
    published: PUBLISH_BADGE[PUBLISH_STATUS.PUBLISHED],
    hidden: PUBLISH_BADGE[PUBLISH_STATUS.HIDDEN],
  };

  GetListingBadge = async () => {
    if (!isCustomerProfile(profile)) return;

    const result = await GET("api/admin/customer/list", { page: 1, page_size: 1 }, false);
    if (!result?.status) return;

    const listing = (result.data || [])[0]?.sale_listing || null;
    if (!listing) return this.setState({ listing_badge: this.LISTING_BADGE.none });

    // ประกาศเก่าที่สร้างก่อนมีคอลัมน์ publish_status — เดาจาก is_published แทน (ดู publishStatusOf)
    const status = publishStatusOf(listing);
    if (status === PUBLISH_STATUS.PUBLISHED) return this.setState({ listing_badge: this.LISTING_BADGE.published });
    if (status === PUBLISH_STATUS.PENDING) return this.setState({ listing_badge: this.LISTING_BADGE.pending });
    return this.setState({ listing_badge: this.LISTING_BADGE.hidden });
  };

  filterMenu = (profile) => {
    // ★ copy ก่อน push คีย์พิเศษ — ไม่งั้นเขียนทับ profile.role.permissions ตัวจริง แล้วการเช็คสิทธิ์ 2 ระบบเพี้ยน
    let perms = [...(profile?.role?.permissions || [])];
    if(!profile?.customer_id){
      perms.push("console.read");
      perms.push("news.read");
      perms.push("announcements.read");
      perms.push("categorized-report.read");
    }else{
      perms = perms.filter(e => e !== "customer.read")
    }
    perms.push("dashboard.read");

    // ★ item.perm = คีย์สิทธิ์ที่ระบุมาเอง ใช้กับเมนูที่ชื่อ link ไม่ตรงกับชื่อคีย์สิทธิ์
    //   (เช่น /project-room-all ใช้สิทธิ์ sale-listing.read) ถ้าไม่ระบุก็เดาจาก link/type เหมือนเดิม
    let menu = global.menu?.filter(
      (item) =>
        !item.link ||
        (item.perm
          ? perms.includes(item.perm)
          : perms.includes(item.link.replace("/","") + ".read") ||
            perms.includes(item.type + ".read"))
    );
    // ★ เช็ค user_type ก่อน project — ลูกค้าก็มี cds-project เก็บไว้ตั้งแต่ตอนล็อกอิน
    //   ถ้าเช็ค project ก่อน เมนูที่เป็น type customer ล้วน ๆ จะถูกกรองทิ้งทั้งหมด
    //   ยังรับ type project ไว้ด้วย เพราะเดิมลูกค้าตกลง branch นั้น — กันเมนูที่เคยเห็นหายไป
    if(isCustomerProfile(profile)){
      menu = menu.filter(e => (e.type)?.includes("customer") || (e.type)?.includes("project") || e.title)
    }else if(project){
      menu = menu.filter(e => (e.type)?.includes("project") || e.title)
    }else{
      menu = menu.filter(e => (e.type)?.includes("admin") || e.title)
    }
    // ★ แยกสิทธิ์ 2 ระบบ — ไม่มีสิทธิ์ฝั่งไหน ซ่อนเมนูฝั่งนั้นทั้งหมด (ลูกบ้านไม่เกี่ยว)
    if(!isCustomerProfile(profile)){
      const sides = getAccessSides(profile);
      menu = menu.filter(e => {
        const side = e.link ? sideOfPath(e.link) : null;
        return !side || sides[side];
      });
    }
    return menu
      .reduce((acc, item) => {
        if (item.title && acc.at(-1)?.title) return acc;
        acc.push(item);
        return acc;
      }, [])
      .filter((_, i, arr) => !(i === arr.length - 1 && arr[i].title));
  };

  permissionSetting = () => {
    const role = new Set(this.state.user_profile?.role?.permissions || []);
    global.permission.forEach((perm) => {
      if (!role.has(perm)) {
        [...document.getElementsByClassName(perm)].forEach((el) => el.remove());
      }
    });
  };

  componentMenu = () => {
    const classNameBTN = "btn btn-outline-dark border-0 w-100 text-start d-flex align-items-center justify-content-start p-1 mb-1 rounded-3";
    const classNameICON = "icon wpx-20 ms-1";
    // ★ ตัด query string / hash ออกก่อนเทียบ — /project-room-edit?customer_id=... ต้องยังตรงกับ altLinks
    const currentPath = `/${window.location.pathname.split("/").pop()}`;
    const linkItem = (href, icon, label, isActive, extra = null) => (
      <a
        href={href}
        className={`${classNameBTN} ${isActive ? "active" : ""}`}
        style={{ borderRadius: 12 }}
      >
        <span className={classNameICON} style={{ borderRadius: 10 }}>
          {icon}
        </span>
        <div className="mx-2">{label}</div>
        {extra}
      </a>
    );

    const { array_link } = this.state;

    return (
      <div>
        {array_link.map((item, i) => {
          if (item.title)
            return (
              <div className="my-2 text-12" key={`title-${i}`}>
                <b>{item.title}</b>
              </div>
            );
          const href = `${item.link}`;
          // #49 เมนูที่รวม 2 หน้าเข้าด้วยกัน (เช่น จัดการทรัพย์ + ข้อมูลทรัพย์/การขาย) ใช้ altLinks
          // ให้ยังไฮไลต์ค้างไว้ตอนสลับแท็บไปหน้าย่อยอีกหน้า
          const isActive = href === currentPath || (item.altLinks || []).includes(currentPath);
          const badge = item.link === "/project-room-all" ? this.state.listing_badge : null;
          return linkItem(
            href,
            item.icon,
            item.name,
            isActive,
            badge ? (
              <span
                className="ms-auto me-1 px-2 py-1 rounded-pill text-10"
                data-testid="listing-badge"
                style={{ background: badge.tint, color: badge.color, whiteSpace: "nowrap" }}
              >
                {badge.label}
              </span>
            ) : (
              item.component
            )
          );
        })}

        <hr />
        <div className="d-none d-xl-block hpx-100"></div>
      </div>
    );
  };
  render() {
    const {profiles,announce_image,
announce_description,
announce_is_active } = this.state;
    return (
      <div>
        <Sidebar
          className="position-fixed bg-white"
          backgroundColor={"#ffffff"}
          style={{
            zIndex: 1000,
            width: "250px", // ความกว้าง sidebar คงที่
            height: "100vh", // ความสูงเต็มจอ
            overflow: "hidden", // ซ่อน scrollbar ด้านนอก
          }}
          breakPoint="lg"
          toggled={this.state.sidebar}
          onFocus={() => {
            this.setState({ sidebar: true });
          }}
        >
          <Menu
            className="d-flex flex-column"
            style={{
              height: "100%",
              overflowY: "auto", // ทำให้ scroll ได้
              paddingBottom: "60px", // กันไม่ให้ติดขอบล่าง
            }}
          >
            <div className="w-100 px-3 d-flex align-items-start justify-content-between my-2">
              <img src={LOGO} height={42} alt="LOGO" className="mx-auto" />
              <span
                className="icon text-24 pointer d-block d-lg-none d-xl-none"
                onClick={() => {
                  this.setState({ sidebar: false });
                }}
              >
                {"\uf00d"}
              </span>
            </div>
            <div className="w-100 text-center">
              <small>v.{process.env.REACT_APP_VERSION}</small><br/>
                  <small className="text-8">
                ©copy right by  c.d.s. service .co.,ltd and OMS service {" "}
              </small></div>
            <div className="px-3">
                {this.componentMenu()}
            </div>
          </Menu>
        </Sidebar>

        <div className="body d-flex align-items-center justify-content-between mb-1 px-3 py-2">
          <div className="d-flex align-items-center">
            {this.props.sidebar !== "false" && (
              <label
                className="me-3 d-block d-lg-none d-xl-none pointer"
                onClick={() => {
                  this.setState({ sidebar: !this.state.sidebar });
                }}
              >
                <span className="icon text-24">{"\uf0c9"}</span>
              </label>
            )}
            <div className="d-none d-sm-flex">
              {this.props.page1 && (
                <label
                  className={
                    this.props.page2 ? "text-secondary" : "text-success"
                  }
                >
                  {this.props.page1}
                </label>
              )}
              {this.props.page2 && (
                <label className="text-secondary mx-2">{">"}</label>
              )}
              {this.props.page2 && (
                <label
                  className={
                    this.props.page3 ? "text-secondary" : "text-success"
                  }
                >
                  {this.props.page2}
                </label>
              )}
              {this.props.page3 && (
                <label className="text-secondary mx-2">{">"}</label>
              )}
              {this.props.page3 && (
                <label className="text-success">{this.props.page3}</label>
              )}
            </div>
          </div>
          <div
            className="d-flex align-items-center bg-white py-1 px-1"
            style={{ borderRadius: 26 }}
          >
            <div className="bg-success-light text-success wpx-40 hpx-40 d-flex justify-content-center align-items-center rounded-circle me-3">
              {profiles?.full_name?.slice(0, 2).toUpperCase() || "US"}
            </div>
            <div className="me-3">
              <div className="fw-bold">
                {profiles?.full_name || "-"}
              </div>
              <small className="me-2">
                {stripJuristic(project?.project_name) || "ผู้ดูแลระบบ"}
              </small>
            </div>
            <Dropdown>
                <Dropdown.Toggle variant="gray" id="dropdown-basic" size="sm">
                  <span className="icon pointer text-24 me-2">{"\uf107"}</span>
                </Dropdown.Toggle>
                <Dropdown.Menu className="shadow overflow-hidden border-0 rounded-4 p-2">
                  {profiles?.customer_id && (
                  <Dropdown.Item
                    className="rounded-3 d-flex align-items-center px-2"
                    onClick={() => {
                      this.GetCustomer();
                    }}
                  >
                    <div className="fw-bold icon me-1 wpx-15 text-center text-12">
                      {"\uf007"}
                    </div>{" "}
                    โปรไฟล์
                  </Dropdown.Item>
                  )}
                  <Dropdown.Item
                    className="rounded-3 d-flex align-items-center px-2"
                    onClick={() => {
                      this.setState({ modal_change_password: true, new_password: "" });
                    }}
                  >
                    <div className="fw-bold icon me-1 wpx-15 text-center text-12">
                      {""}
                    </div>{" "}
                    เปลี่ยนรหัสผ่าน
                  </Dropdown.Item>
                  <Dropdown.Item
                    className="rounded-3 d-flex align-items-center px-2"
                    onClick={async () => {
                      if (
                        await alert(
                          "",
                          "warning",
                          "ออกจากระบบ",
                          "ยืนยันการออกจากระบบหรือไม่?",
                          "ออกจากระบบ",
                          "ยกเลิก"
                        )
                      ) {
                        localStorage.clear();
                        window.location.href = "/";
                      }
                    }}
                  >
                    <div className="fw-bold icon me-1 wpx-15 text-center text-12">
                      {"\uf2f5"}
                    </div>{" "}
                    ออกจากระบบ
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
          </div>
        </div>
        <Modal show={this.state.modal_change_password} onHide={() => this.setState({ modal_change_password: false, old_password: "", new_password: "" })}>
          <Modal.Header>
            <h4 className="fw-bold mb-0">เปลี่ยนรหัสผ่าน</h4>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-3">
              <label className="fw-bold mb-1">รหัสผ่านเดิม</label>
              <input
                type="password"
                className="form-control"
                placeholder="กรอกรหัสผ่านเดิม"
                value={this.state.old_password}
                onChange={(e) => this.setState({ old_password: e.target.value })}
              />
            </div>
            <div className="mb-2">
              <label className="fw-bold mb-1">รหัสผ่านใหม่</label>
              <input
                type="password"
                className="form-control"
                placeholder="กรอกรหัสผ่านใหม่"
                value={this.state.new_password}
                onChange={(e) => this.setState({ new_password: e.target.value })}
              />
            </div>
          </Modal.Body>
          <Modal.Footer className="py-1">
            <div className="w-100 d-flex justify-content-center gap-2 p-1">
              <button
                className="btn btn-outline-danger px-5"
                onClick={() => this.setState({ modal_change_password: false, old_password: "", new_password: "" })}
              >
                ยกเลิก
              </button>
              <button
                className="btn btn-success px-5"
                onClick={this.ChangePassword}
              >
                บันทึก
              </button>
            </div>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.modal_detail} size="lg" onHide={()=>{this.setState({modal_detail:false})}}>
          <Modal.Header>
            <h4 className="fw-bold mb-0">ข้อมูลส่วนตัว</h4>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-6">
                <div className="d-flex mb-2">
                  <label className="wpx-100">ชื่อ - สกุล</label>
                  <label className="px-2">:</label>
                  <label>{this.state?.detail?.full_name || "-"}</label>
                </div>
                <div className="d-flex mb-2">
                  <label className="wpx-100">เลขบัตรประชาชน</label>
                  <label className="px-2">:</label>
                  <label>{this.state?.detail?.id_card || "-"}</label>
                </div>
                <div className="d-flex mb-2">
                  <label className="wpx-100">โครงการ</label>
                  <label className="px-2">:</label>
                  <label>{stripJuristic(this.state?.detail?.project_name) || "-"}</label>
                </div>
                <div className="d-flex mb-2">
                  <label className="wpx-100">บ้านเลขที่</label>
                  <label className="px-2">:</label>
                  <label>{this.state?.detail?.address_number || "-"}</label>
                </div>
                <div className="d-flex mb-2">
                  <label className="wpx-100">อาคาร</label>
                  <label className="px-2">:</label>
                  <label>{this.state?.detail?.building || "-"}</label>
                </div>
                <div className="d-flex mb-2">
                  <label className="wpx-100">ชั้น</label>
                  <label className="px-2">:</label>
                  <label>{this.state?.detail?.floor || "-"}</label>
                </div>
                <div className="d-flex mb-2">
                  <label className="wpx-100">ขนาดห้อง (ตรม.)</label>
                  <label className="px-2">:</label>
                  <label>{this.state?.detail?.room_size || "-"}</label>
                </div>
                <div className="d-flex mb-2">
                  <label className="wpx-100">โทรศัพท์บ้าน</label>
                  <label className="px-2">:</label>
                  <label>{this.state?.detail?.home_phone || "-"}</label>
                </div>
                <div className="d-flex mb-2">
                  <label className="wpx-100">โทรศัพท์มือถือ</label>
                  <label className="px-2">:</label>
                  <label>{this.state?.detail?.mobile_phone || "-"}</label>
                </div>
              </div>
              <div className="col-6">
                <div className="d-flex mb-2">
                  <label className="wpx-100">วันที่ส่งมอบ</label>
                  <label className="px-2">:</label>
                  <label>
                    {this.state?.detail?.delivery_date
                      ? format_date(
                          this.state?.detail?.delivery_date,
                          "yyyy-mm-dd hh:mm:ss",
                          "en"
                        )
                      : "-"}
                  </label>
                </div>
                <div className="d-flex mb-2">
                  <label className="wpx-100">วันที่มารับมอบ</label>
                  <label className="px-2">:</label>
                  <label>
                    {this.state?.detail?.receive_date
                      ? format_date(
                          this.state?.detail?.receive_date,
                          "yyyy-mm-dd hh:mm:ss",
                          "en"
                        )
                      : "-"}
                  </label>
                </div>
                <div className="d-flex mb-2">
                  <label className="wpx-100">วันที่โอน</label>
                  <label className="px-2">:</label>
                  <label>
                    {this.state?.detail?.transfer_date
                      ? format_date(
                          this.state?.detail?.transfer_date,
                          "yyyy-mm-dd hh:mm:ss",
                          "en"
                        )
                      : "-"}
                  </label>
                </div>
                <div className="d-flex mb-2">
                  <label className="wpx-100">สถานะการโอน</label>
                  <label className="px-2">:</label>
                  <label>
                    {global.status_transfer[this.state?.detail?.status_transfer] || "-"}
                  </label>
                </div>
                <div className="d-flex mb-2">
                  <label className="wpx-100">เลขที่เงินกู้</label>
                  <label className="px-2">:</label>
                  <label>{this.state?.detail?.loan_number || "-"}</label>
                </div>
                <div className="d-flex mb-2">
                  <label className="wpx-100">วงเงินกู้</label>
                  <label className="px-2">:</label>
                  <label>{this.state?.detail?.credit_limit || "-"}</label>
                </div>
                <div className="d-flex mb-2">
                  <label className="wpx-100">เงินงวด</label>
                  <label className="px-2">:</label>
                  <label>{this.state?.detail?.installment || "-"}</label>
                </div>
                <div className="d-flex mb-2">
                  <label className="wpx-100">วันที่ทำสัญญา</label>
                  <label className="px-2">:</label>
                  <label>
                    {this.state?.detail?.contract_date
                      ? format_date(
                          this.state?.detail?.contract_date,
                          "yyyy-mm-dd hh:mm:ss",
                          "en"
                        )
                      : "-"}
                  </label>
                </div>
                <div className="d-flex mb-2">
                  <label className="wpx-100">ซื้ออาคารโดย</label>
                  <label className="px-2">:</label>
                  <label>
                    {global.status_buy_building[
                      this.state?.detail?.status_buy_building
                    ] || "-"}
                  </label>
                </div>
              </div>
              <div className="col-12">
                <div className="d-flex mb-2">
                  <label className="wpx-100">ที่อยู่</label>
                  <label className="px-2">:</label>
                  <label>{this.state?.detail?.address || "-"}</label>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="py-1">
            <div className="w-100 d-flex justify-content-center p-1">
              <button
                className="btn btn-outline-success px-5"
                onClick={() => {
                  this.setState({ modal_detail: false });
                }}
              >
                ปิดหน้าต่าง
              </button>
            </div>
          </Modal.Footer>
        </Modal>
        {/* ---------------- ประกาศแจ้งเตือนของโครงการ ----------------
            ★ เด้งมุมขวาล่าง ไม่ใช่ modal กลางจอ — ผู้ใช้ยังทำงานต่อได้ระหว่างอ่าน
            ★ ข้อความอาจยาว (ประกาศปิดน้ำ/ปิดลิฟต์) จึงจำกัดความสูงแล้วเลื่อนในกล่อง */}
        {announce_is_active && (
          <div className="ann-toast shadow">
            <div className="ann-toast__head">
              <span className="ann-toast__title">
                <span className="icon">{"\uf0a1"}</span>
                ประกาศแจ้งเตือน
              </span>
              <button
                type="button"
                className="ann-toast__close icon"
                title="ปิด"
                onClick={() => this.setState({ announce_is_active: false })}
              >
                {"\uf00d"}
              </button>
            </div>

            {!!announce_image && (
              <div className="ann-toast__media">
                <img alt="ประกาศ" src={announce_image} />
              </div>
            )}

            {!!announce_description && <div className="ann-toast__body">{announce_description}</div>}

            <div className="ann-toast__foot">
              <button
                type="button"
                className="btn btn-success btn-sm px-4 w-100"
                onClick={() => this.setState({ announce_is_active: false })}
              >
                รับทราบ
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}
